import { render, staticRenderFns } from "./BaseSlotCard.vue?vue&type=template&id=20556082&scoped=true&"
import script from "./BaseSlotCard.vue?vue&type=script&lang=js&"
export * from "./BaseSlotCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseSlotCard.vue?vue&type=style&index=0&id=20556082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20556082",
  null
  
)

export default component.exports